<!-- @format -->

<section id="plp-component-feature-single-spot">
	<a
		class="{{
			textBoxPositionVariants[textBoxPosition]
		}} plp-component-feature-single-spot-container hmf-display-flex hmf-flex-row hmf-flex-wrap hmf-justify-content-center hmf-sharp-radius hmf-position-relative"
		[href]="link"
		tabindex="0"
		role="link"
		[attr.data-em]="dataEm">
		<div
			class="plp-component-feature-single-spot-image-container hmf-display-flex hmf-justify-content-center">
			@if (image) {
				<picture>
					@if (mobileImage) {
						<source
							[srcset]="mobileImage"
							media="(max-width: 766px)" />
					}
					<img
						[src]="image"
						class="loaded plp-component-feature-img"
						role="img"
						loading="lazy"
						[attr.alt]="altText" />
				</picture>
			}
		</div>
		<div class="plp-component-feature-single-spot-copybox-container">
			<div
				class="plp-component-feature-single-spot-copybox hmf-display-flex hmf-flex-column hmf-justify-content-center hmf-mx-m-0 hmf-p-s hmf-px-m-l {{
					textColorVariants[textColor]
				}} {{ textBoxBackgroundColorVariants[textBoxBackgroundColor] }}">
				@if (upperText) {
					<p
						class="plp-component-feature-uppertext hmf-header-s hmf-header-m-m hmf-mb-0 hmf-pb-m-xs hmf-pb-xxs">
						{{ upperText }}
					</p>
				}
				@if (headline) {
					<h2
						class="plp-component-feature-headline hmf-display-s hmf-display-m-m hmf-pb-xxs {{ headlineFont[fontFamily] }}">
						{{ headline }}
					</h2>
				}
				@if (subhead) {
					<p
						class="plp-component-feature-subhead hmf-header-s hmf-header-m-m hmf-pb-m-s hmf-pb-m-m {{
							subHeadlineFont[fontFamily]
						}}">
						{{ subhead }}
					</p>
				}
				@if (detailsText) {
					<p
						class="plp-component-feature-single-spot-details-text hmf-legal-xs hmf-mb-m-s">
						{{ detailsText }}&nbsp;<a
							class="plp-component-feature-single-spot-details-link {{
								textColorVariants[textColor]
							}}"
							[href]="detailsLink"
							tabindex="0"
							>Details</a
						>
					</p>
				}
			</div>
		</div>
	</a>
</section>
